import { motion } from 'framer-motion';
import { Skeleton } from '@/components/ui/skeleton';

export const WorkspaceListSkeleton = () => (
  <div className="flex flex-col gap-2">
    {[0, 1, 2].map(i => (
      <motion.div
        animate={{ opacity: 1, y: 0 }}
        className="rounded-lg bg-white p-4 shadow-verail"
        initial={{ opacity: 0, y: 10 }}
        key={i}
        transition={{ duration: 0.3, delay: i * 0.1 }}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Skeleton className="h-4 w-4 rounded-full" />
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-5 w-20 rounded-full" />
          </div>
          <div className="flex items-center gap-1">
            <Skeleton className="h-8 w-8 rounded-md" />
            <Skeleton className="h-8 w-8 rounded-md" />
          </div>
        </div>
      </motion.div>
    ))}
  </div>
);
